










































import { Component, Watch } from 'vue-property-decorator'
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import DepositAccountSummary from '@/models/Accounts/DepositAccounts/DepositAccountSummary';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import FilterAccountsRequest from '@/models/Shared/FilterAccountsRequest';
import AccountSearchType from '@/models/Shared/AccountSearchType';
import ListUtils from '@/lib/listUtils';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';
import { Debounce } from 'vue-debounce-decorator';

@Component({ name: 'LendingAccounts', components: { Alert, AccountState }, metaInfo: { title: 'Lending Accounts' } })
export default class extends SaascadaVue {

    PayeeType = PayeeType;

    headers = [
        { text: this.$t('pageText.lendingAccounts.fields.accountName'), sortable: false, width: "35%" },
        { text: this.accountColumnHeader, sortable: false, width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.productIssue'), sortable: false, width: "25%" },
        { text: this.$t('pageText.lendingAccounts.fields.productSubType'), sortable: false, width: "15%" },
        { text: this.$t('pageText.lendingAccounts.fields.state'), sortable: false, width: "10%" }
    ];
    accountsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.accountsPage = +page;
        }
    }

    async beforeMount() {
        const request = new FilterAccountsRequest();
        request.pageNumber = this.accountsPage;
        await LendingAccountModule.getLendingAccounts(request);
    }

    get accounts() {
        return LendingAccountModule.lendingAccounts;
    }

    get searchTypeOptions() {
        return ListUtils.accountSearchTypeOptions();
    }

    get totalAccountsPages() {
        return LendingAccountModule.totalLendingAccountsPages;
    }

    get search() {
        return LendingAccountModule.lendingAccountsSearch;
    }

    set search(searchText: string) {
        LendingAccountModule.updateLendingAccountsSearch(searchText);
    }

    get searchType() {
        return LendingAccountModule.lendingAccountsSearchType;
    }

    set searchType(searchType: AccountSearchType) {
        LendingAccountModule.updateLendingAccountsSearchType(searchType);
    }

    get loading() {
        return LendingAccountModule.loadingLendingAccounts;
    }

    get pageSize() {
        return LendingAccountModule.pageSize;
    }

    get accountColumnHeader() {
        // Get the heading for the account column in the table, depending on what payee types are available
        if (this.availablePayeeTypes.includes(PayeeType.UK)) {
            return this.$t('pageText.lendingAccounts.fields.accountNumber');
        }
        else {
            return this.$t('pageText.lendingAccounts.fields.iban');
        }
    }

    get availablePayeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

    @Watch('accountsPage')
    async onAccountsPageChanged() {
        // Update current page route with page number
        this.$router.push({ name: this.$route.name, query: { page: `${this.accountsPage}` } });
        // Get new lending accounts
        const request = new FilterAccountsRequest();
        request.pageNumber = this.accountsPage;
        await LendingAccountModule.getLendingAccounts(request);
    }

    @Watch('searchType')
    async searchTypeChanged() {
        // If the search is not empty we need to clear it, otherwise do nothing
        if (this.search !== '') {
            this.search = '';
            // Then get all accounts with no search or pagination
            const request = new FilterAccountsRequest();
            request.pageNumber = 1;
            await LendingAccountModule.getLendingAccounts(request);
        }
    }

    // Wait before auto-searching to allow the user to type more
    @Debounce(500)
    @Watch("search", { immediate: false, deep: true })
    async searchChanged() {
        const request = new FilterAccountsRequest();

        // Reset back to the first page when searching
        request.pageNumber = 1;
        this.accountsPage = 1;

        await LendingAccountModule.getLendingAccounts(request);
    }

    async navigateToLendingAccount(account: DepositAccountSummary) {
        this.$router.push({ name: PageNames.LendingAccount, params: { id: account.id }, query: { tab: "0" } });
    }

}
